const css = `._modal_1jrui_1 {
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 100;
}
._modalCardWrapper_1jrui_12 {
  animation: _modalFadeIn_1jrui_1 0.15s cubic-bezier(1, 0.01, 0.2, 1);
  max-height: 80vh;
  overflow-y: auto;
  width: 90%;
  max-width: 576px;
  z-index: 200;
}
._modalCardWrapperFooter_1jrui_20 {
  bottom: 0;
  position: sticky;
}
._modalOverlay_1jrui_24 {
  background-color: var(--modal-background-color);
  border: 0 none transparent;
  height: 100vh;
  left: 0;
  position: absolute;
  top: 0;
  width: 100vw;
  z-index: 100;
}

@keyframes _modalFadeIn_1jrui_1 {
  0% {
    opacity: 0;
    transform: scale(0.7);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "modal": "_modal_1jrui_1",
  "modalCardWrapper": "_modalCardWrapper_1jrui_12",
  "modalFadeIn": "_modalFadeIn_1jrui_1",
  "modalCardWrapperFooter": "_modalCardWrapperFooter_1jrui_20",
  "modalOverlay": "_modalOverlay_1jrui_24"
};